import _extends from "@babel/runtime-corejs3/helpers/extends";
import React, { useRef } from 'react';
import { getCompProps } from '../_utils';
import { isFragment } from '../_utils/reactNode';
import { ConfigContext } from '../config-provider';
import usePopper from '../_utils/usePopper';
var Tooltip = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _React$useContext = React.useContext(ConfigContext),
    getPrefixCls = _React$useContext.getPrefixCls,
    pkgPrefixCls = _React$useContext.prefixCls,
    userDefaultProps = _React$useContext.compDefaultProps;
  // 属性需要合并一遍用户定义的默认属性
  var allProps = getCompProps('ToolTip', userDefaultProps, props);
  var status = useRef();
  var tip = allProps.tip,
    children = allProps.children,
    customPrefixcls = allProps.prefixCls;
  // className前缀
  var prefixCls = getPrefixCls(pkgPrefixCls, 'tooltip', customPrefixcls);
  var tiplocator = /*#__PURE__*/React.cloneElement( /*#__PURE__*/React.isValidElement(children) && !isFragment(children) ? children : /*#__PURE__*/React.createElement("span", null, children), {
    ref: /*#__PURE__*/React.isValidElement(children) && !isFragment(children) && children.ref ? children.ref : ref
  });
  var onVisibleChange = function onVisibleChange(v) {
    if (status.current === v && allProps.visible === undefined) return;
    status.current = v;
    props.onVisibleChange && props.onVisibleChange(v);
  };
  var popperProps = _extends(_extends({}, allProps), {
    prefixCls: prefixCls,
    onVisibleChange: onVisibleChange
  });
  var tipPopper = typeof tip === 'function' ? tip() : tip;
  return usePopper(tiplocator, tipPopper, popperProps);
});
Tooltip.displayName = 'Tooltip';
export default Tooltip;